import { createFileRoute } from "@tanstack/react-router";
import AdminAssistants from "@/pages/admin/AdminAssistants";

export const Route = createFileRoute("/admin/asistentes")({
  head: () => ({ meta: [
    { title: "Asistentes y poses | Retail Lemon" },
    { name: "description", content: "Biblioteca y simulación de asistentes de Retail Lemon." },
    { property: "og:title", content: "Asistentes y poses | Retail Lemon" },
    { property: "og:description", content: "Biblioteca y simulación de asistentes de Retail Lemon." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
  ] }),
  component: AdminAssistants,
});
